export default "__VITE_ASSET__D5F3NO0q__"